import { jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation-10";
import bash from "react-syntax-highlighter/dist/cjs/languages/prism/bash";
import cpp from "react-syntax-highlighter/dist/cjs/languages/prism/cpp";
import csharp from "react-syntax-highlighter/dist/cjs/languages/prism/csharp";
import css from "react-syntax-highlighter/dist/cjs/languages/prism/css";
import java from "react-syntax-highlighter/dist/cjs/languages/prism/java";
import javascript from "react-syntax-highlighter/dist/cjs/languages/prism/javascript";
import json from "react-syntax-highlighter/dist/cjs/languages/prism/json";
import jsx2 from "react-syntax-highlighter/dist/cjs/languages/prism/jsx";
import markdown from "react-syntax-highlighter/dist/cjs/languages/prism/markdown";
import html from "react-syntax-highlighter/dist/cjs/languages/prism/markup";
import python from "react-syntax-highlighter/dist/cjs/languages/prism/python";
import scss from "react-syntax-highlighter/dist/cjs/languages/prism/scss";
import sql from "react-syntax-highlighter/dist/cjs/languages/prism/sql";
import tsx from "react-syntax-highlighter/dist/cjs/languages/prism/tsx";
import typescript from "react-syntax-highlighter/dist/cjs/languages/prism/typescript";
import yaml from "react-syntax-highlighter/dist/cjs/languages/prism/yaml";
import PrismLight from "react-syntax-highlighter/dist/cjs/prism-light";
import oneLight from "react-syntax-highlighter/dist/cjs/styles/prism/one-light";
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "./Code.constants.esm.js";
PrismLight.registerLanguage("bash", bash);
PrismLight.registerLanguage("shell", bash);
PrismLight.registerLanguage("csharp", csharp);
PrismLight.registerLanguage("css", css);
PrismLight.registerLanguage("cpp", cpp);
PrismLight.registerLanguage("html", html);
PrismLight.registerLanguage("xml", html);
PrismLight.registerLanguage("java", java);
PrismLight.registerLanguage("javascript", javascript);
PrismLight.registerLanguage("json", json);
PrismLight.registerLanguage("jsx", jsx2);
PrismLight.registerLanguage("markdown", markdown);
PrismLight.registerLanguage("python", python);
PrismLight.registerLanguage("scss", scss);
PrismLight.registerLanguage("sql", sql);
PrismLight.registerLanguage("tsx", tsx);
PrismLight.registerLanguage("typescript", typescript);
PrismLight.registerLanguage("yaml", yaml);
const Code = ({
  content,
  language = DEFAULT_LANGUAGE,
  showLineNumbers = false,
  startingLineNumber = 1
}) => {
  if (!content || !content.trim()) {
    return null;
  }
  const normalizedLanguage = language.toLowerCase().trim();
  const isValidLanguage = SUPPORTED_LANGUAGES.includes(normalizedLanguage);
  const validatedLanguage = isValidLanguage ? normalizedLanguage : DEFAULT_LANGUAGE;
  const codeLanguage = validatedLanguage === "text" ? "" : validatedLanguage;
  return /* @__PURE__ */ jsx(Box, { css: {
    backgroundColor: "bg.softest",
    borderRadius: "obj.default",
    fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace',
    fontSize: "body-sm",
    lineHeight: "body-sm",
    padding: "default"
  }, children: /* @__PURE__ */ jsx(PrismLight, { language: codeLanguage, style: oneLight, showLineNumbers, startingLineNumber, customStyle: {
    margin: 0,
    padding: 0,
    background: "transparent",
    fontFamily: "inherit"
  }, codeTagProps: {
    style: {
      // This has to be present otherwise the code has a white highlight for some reason
    }
  }, lineNumberStyle: {
    minWidth: "2.5em",
    paddingRight: "1em",
    textAlign: "right",
    userSelect: "none",
    opacity: 0.5
  }, children: content }) });
};
export {
  Code as default
};
